module.exports = __webpack_public_path__ + "assets/swiss.a3c45ec3720625edf81307b7ef06a775.svg?";